import { deleteData, getData, postData, putData } from '../utils/httputils';

class Customers {
  static apiPath = '/api/v1/admin/customers';

  static create(data) {
    return postData(Customers.apiPath, data);
  }

  static find(params) {
    const { limit, offset, order_by, sort, search } = params;
    const searchQuery = search ? '&search=' + search : '';
    return getData(
      `${Customers.apiPath}?limit=${limit || 10}&offset=${offset || 0}&order_by=${order_by || 'id'}&sort=${sort ||
        'desc'}${searchQuery}`
    );
  }

  static get(id) {
    return getData(`${Customers.apiPath}/${id}`);
  }

  static update(id, field, value) {
    return putData(`${Customers.apiPath}/${id}`, { field, value });
  }

  static delete = id => {
    return deleteData(`${Customers.apiPath}/${id}`);
  };
}

export default Customers;
